<div class="bg-white shadow-lg rounded p-4 mt-1 w-full mx-auto mb-2">
    <div class="animate-pulse flex space-x-4">
        <div class="flex-1 space-y-2">
            <div class="h-3 w-1/4 bg-slate-200 rounded"></div>
            <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
            <div class="space-y-2">
                <div class="flex flex-row gap-2 justify-start items-center">
                    <div class="h-4 w-4/12 bg-slate-200 rounded"></div>
                    <div class="h-4 w-8/12 bg-slate-200 rounded"></div>
                </div>
                <div class="flex flex-row gap-2 justify-start items-center">
                    <div class="h-4 w-8/12 bg-slate-200 rounded"></div>
                </div>
            </div>
        </div>
    </div>
</div>